export default __webpack_public_path__ + "static/media/icon-asc.28032740.svg";